import { render, staticRenderFns } from "./RoyaltyPoint.vue?vue&type=template&id=72b1aa27&scoped=true&"
import script from "./RoyaltyPoint.vue?vue&type=script&lang=js&"
export * from "./RoyaltyPoint.vue?vue&type=script&lang=js&"
import style0 from "./RoyaltyPoint.vue?vue&type=style&index=0&id=72b1aa27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b1aa27",
  null
  
)

export default component.exports